<div [ngClass]="{'tab-pane': true, active: isActive}">
    <form
        [formGroup]="settingsForm"
        (ngSubmit)="onSubmit()"
        class="form-horizontal"
    >
        <div class="form-group row">
            <label for="inputName" class="col-sm-2 col-form-label">Name</label>
            <div class="col-sm-10">
                <input
                    type="text"
                    class="form-control"
                    id="inputName"
                    formControlName="name"
                    placeholder="Name"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="inputEmail" class="col-sm-2 col-form-label"
                >Email</label
            >
            <div class="col-sm-10">
                <input
                    type="email"
                    class="form-control"
                    id="inputEmail"
                    formControlName="email"
                    placeholder="Email"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="inputName2" class="col-sm-2 col-form-label">Name</label>
            <div class="col-sm-10">
                <input
                    type="text"
                    class="form-control"
                    id="inputName2"
                    formControlName="name2"
                    placeholder="Name"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="inputExperience" class="col-sm-2 col-form-label"
                >Experience</label
            >
            <div class="col-sm-10">
                <textarea
                    class="form-control"
                    id="inputExperience"
                    formControlName="experience"
                    placeholder="Experience"
                ></textarea>
            </div>
        </div>
        <div class="form-group row">
            <label for="inputSkills" class="col-sm-2 col-form-label"
                >Skills</label
            >
            <div class="col-sm-10">
                <input
                    type="text"
                    class="form-control"
                    id="inputSkills"
                    formControlName="skills"
                    placeholder="Skills"
                />
            </div>
        </div>
        <div class="form-group row">
            <div class="offset-sm-2 col-sm-10">
                <div class="icheck-primary">
                    <input
                        type="checkbox"
                        id="agreeTerms"
                        formControlName="agreeTerms"
                        class="mr-2"
                    />
                    <label for="agreeTerms">
                        <span>I agree to the </span>
                        <a routerLink="/">terms and conditions</a>
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="offset-sm-2 col-sm-10">
                <button type="submit" class="btn btn-danger">Submit</button>
            </div>
        </div>
    </form>
</div>
